import React, { useCallback } from "react";
import { Modal } from "react-bootstrap";

import { AddColumnToNormalizationForm } from "containers/commissions/addColumnToNormalizationForm";

export type AddColumnToNormalizationModalProps = {
	show: boolean;
	onHide: () => void;
	entityId: string;
	submitService: Function;
	handleSuccessfulAddingPaymentMethod: Function;
};

const AddColumnToNormalizationModal = ({
	show,
	onHide,
	entityId,
	submitService,
	handleSuccessfulAddingPaymentMethod,
}: AddColumnToNormalizationModalProps) => {
	const onSuccess = useCallback(
		id => {
			onHide();
			handleSuccessfulAddingPaymentMethod?.();
		},
		[handleSuccessfulAddingPaymentMethod, onHide],
	);
	return (
		<Modal
			show={show}
			onHide={onHide}
			animation={false}
			centered
			scrollable
		>
			<Modal.Header closeButton>
				<Modal.Title as="h6" className="text-center">
					Add Column to Normalization
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-form-container">
					<AddColumnToNormalizationForm
						entityId={entityId}
						submitService={submitService}
						onSuccess={onSuccess}
					/>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default AddColumnToNormalizationModal;
